// Per-platform theming + copy. One source of truth for the Apple/Android
// toggle. Hex values become CSS vars at runtime via PlatformContext.
export const PLATFORMS = {
  apple: {
    id: "apple",
    label: "Apple",
    short: "Apple",
    network: "Apple Find My",
    networkShort: "Find My",
    accent: "#FF6B00",
    accentHover: "#E55A00",
    accentSoft: "rgba(255,107,0,0.10)",
    accentRing: "rgba(255,107,0,0.25)",
    accentGlow: "0 20px 60px rgba(255,107,0,0.35)",
    pageTint: "#FBFBFD", // paper
    heroEyebrow: "Magnetic tracker · Apple Find My",
    heroTag: "Tracksy for Apple",
    announce: "Magnetic tracking that pairs with Apple Find My — unlimited range, zero fees.",
    chipRange: "Unlimited Range",
    chipNetwork: "Works with Apple Find My",
    pitch:
      "Pair in 60 seconds through the Find My app already on your iPhone. The same global network your AirPods and AirTags live on — now with a magnetic matte-black case built for cars, trailers and gear.",
    requirements: "iPhone or iPad on iOS / iPadOS 14.8+",
  },
  android: {
    id: "android",
    label: "Android",
    short: "Android",
    network: "Google Find Hub",
    networkShort: "Find Hub",
    accent: "#1A73E8",
    accentHover: "#1557C0",
    accentSoft: "rgba(26,115,232,0.12)",
    accentRing: "rgba(26,115,232,0.28)",
    accentGlow: "0 20px 60px rgba(26,115,232,0.35)",
    pageTint: "#F6F9FF",
    heroEyebrow: "Magnetic tracker · Google Find Hub",
    heroTag: "Tracksy for Android",
    announce: "Magnetic tracking that pairs with Google Find Hub — unlimited range, zero fees.",
    chipRange: "Unlimited Range",
    chipNetwork: "Works with Google Find Hub",
    pitch:
      "Pair in 60 seconds through Google's Find Hub app on your Android phone. A worldwide crowdsourced locator — now with a magnetic matte-black case built for cars, trailers and gear.",
    requirements: "Android 9+ with Google Play services and Find Hub enabled",
  },
};

export const PLATFORM_IDS = Object.keys(PLATFORMS);
export const DEFAULT_PLATFORM = "apple";
